/**
 * String manipulation utilities
 */

/**
 * Truncate text to a maximum length with optional suffix
 * @param {string} text - Text to truncate
 * @param {number} maxLength - Maximum length (default: 15)
 * @param {string} suffix - Suffix to add when truncated (default: '...')
 * @returns {string} Truncated text
 */
export const truncateText = (text, maxLength = 15, suffix = '...') => {
  if (!text || text === 'n/a') return 'n/a';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - suffix.length) + suffix;
};

export default { truncateText };
